// extracted by mini-css-extract-plugin
export default {"root":"common-components-SearchField-SearchField__root--ZGvdQ"};